<mat-dialog-content>
  <h1 class="mt-0" mat-dialog-title>
    {{ 'Courses.Overview.MoveLecture' | translate }}
  </h1>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>{{ 'Global.SelectSection' | translate }}</mat-label>
    <mat-select [(value)]="selectedSection._id">
      @for (element of sectionList; track element) {
        <mat-option [(value)]="element._id">
          {{ element.actualName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button color="accent" (click)="cancel()">
    {{ 'Confirm.Cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save()">
    {{ 'Global.Save' | translate }}
  </button>
</mat-dialog-actions>
